import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { Link } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';

const logo = require('./images/hipkar-logo-text.png');

const styles = theme => ({
  footerText: {
    //color: theme.palette.primary.contrastText,
  },
  footer: {
   display: 'flex',
   height: '35px',
   flexGrow: 1,
   //width:'calc(100% - 240px)',
   justifyContent: 'center',
   alignItems: 'center',
   position:'fixed',
   bottom:0,
   //zIndex: 4,
  },
  newFooter: {
    display: 'flex',
    marginTop: 36,
    marginBottom: 12,
    position:'relative',
    width: '100%',
    bottom: 0,
    zIndex: 1,
  },
  footerLogo: {
    height: 36,
    float: 'right',
  },
  right_align: {
    clear: 'right',
    'text-align': 'right',
  },
  hidden: {
    display: 'none',
  },
  off_screen: {
    position: 'absolute',
    left: '-5000px',
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
  },
  div_with_margin: {
    margin: 8,
  }
});


class Footer extends React.Component {

  render() {
    const { classes, leasyZip } = this.props;

    return (
		<footer id="footer" className={classes.newFooter}>

			
      <Grid container alignItems="stretch" justify="space-between" spacing={8}>
        <Grid item xs={6}>
          
          <form action="https://hipkar.us4.list-manage.com/subscribe/post?u=d4fb5b36c4cf4d29a66cf8f49&amp;id=167b896f92" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank" novalidate>
								    <div className={classes.div_with_margin}>
                    <Typography variant="body1" >
                      To get the best deals via email every month, subscribe here.
                    </Typography>
                    <Typography variant="body1" >
												
                        <TextField
                          id="mce-EMAIL"
                          label="Email"
                          className={classes.textField}
                          type="email"
                          name="EMAIL"
                          autoComplete="email"
                          margin="normal"
                          variant="outlined"
                        />
                        <Button variant="outlined" size="small" color="primary"  type="submit">
                          Subscribe
                        </Button>
										</Typography>
                    
                    <Typography variant="body1" >
                          <input type="text" value={leasyZip} name="MMERGE6" className={classes.hidden} id="mce-MMERGE6" />
                    </Typography>
											<div id="mce-responses" class="clear">
												<div class="response" id="mce-error-response" className={classes.hidden}></div>
												<div class="response" id="mce-success-response" className={classes.hidden}></div>
											</div> 
										  <div className={classes.off_screen} aria-hidden="true"><input type="text" name="b_d4fb5b36c4cf4d29a66cf8f49_167b896f92" tabindex="-1" value=""/></div>
										  {/* <input type="submit" value="Subscribe" name="subscribe" id="mc-embedded-subscribe" class="btn btn-primary" /> */}
                      
								    </div>
								</form>
    
        </Grid>
        <Grid item xs={6}>
        <div className={classes.div_with_margin}>
        <img src={logo} alt="HipKar Logo" className={classes.footerLogo} />
        <Typography variant="caption" className={classes.right_align}>
            For questions, contact us at <a href="mailto:hello@hipkar.com">hello@hipkar.com</a>
          </Typography>
          <Typography variant="caption" className={classes.right_align}>
            Copyright &copy; 2020 HipKar Inc. | All Rights Reserved
          </Typography>
					<Typography variant="caption" className={classes.right_align}>
            <a href="tos.html">Terms of Use</a> / <a href="privacy.html">Privacy Policy</a>
          </Typography>
          </div>
        </Grid>
        
      </Grid>
				{/* <div class="container clearfix">
					<div class="row clearfix">
						<div class="col-lg-5">
								<div class="row clearfix">
									<div class="col-lg-8 clearfix">
										<img src={logo} alt="HipKar Logo" height="50" />
									</div>
								</div>
						</div>
					</div>
					<div class="row">
						<div class="col-lg-4">
							Copyright &copy; 2020 HipKar Inc.<br/>
							<div class="copyright-links"><a href="tos.html">Terms of Use</a> / <a href="privacy.html">Privacy Policy</a></div>
						</div>
						<div class="col-lg-8">
							<div class="widget widget_links app_landing_widget_link clearfix">
								<p class="text-right">For questions, contact us at <a href="mailto:hello@hipkar.com">hello@hipkar.com</a></p>

							</div>
						</div>
					</div>
				</div> */}

			

		</footer>
    );
  }

}

Footer.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Footer);



// WEBPACK FOOTER //
// ./src/components/Footer.jsx